import React from 'react';

import { Icon } from '@chakra-ui/react';

export const AzureEventHubsIcon = props => (
  <Icon viewBox="0 0 720 720" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-192 0)">
      <g>
        <path
          d="M625.2 336.8C625.432 342.398 621.188 347.174 615.6 347.6L532 347.6C526.402 347.832 521.626 343.587 521.2 338L521.2 275.6C520.968 270.002 525.213 265.226 530.8 264.8L614.4 264.8C620 264.568 624.772 268.813 625.2 274.4L625.2 336.8Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
        <path
          d="M773.6 400C773.832 405.6 769.588 410.372 764 410.8L680.4 410.8C674.8 411.032 670.028 406.788 669.6 401.2L669.6 339.2C669.368 333.602 673.612 328.826 679.2 328.4L762.8 328.4C768.4 328.168 773.172 332.413 773.6 338L773.6 400Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
        <path
          d="M625.2 464C625.432 469.6 621.188 474.372 615.6 474.8L532 474.8C526.402 475.032 521.626 470.788 521.2 465.2L521.2 402.8C520.968 397.202 525.213 392.426 530.8 392L614.4 392C620 391.768 624.772 396.013 625.2 401.6L625.2 464Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
        <path
          d="M476.8 273.6C477.032 278.978 472.966 283.574 467.6 284L381.6 284C376.142 284.246 371.425 280.227 370.8 274.8L370.8 210C370.988 204.709 375.121 200.404 380.4 200L464 200C472.8 200 476.8 204.4 476.8 210.8Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
        <path
          d="M476.8 400C477.258 405.504 473.168 410.336 467.664 410.796 467.642 410.796 467.621 410.8 467.6 410.8L381.6 410.8C375.861 411.024 371.025 406.556 370.8 400.816 370.789 400.544 370.789 400.272 370.8 400L370.8 336.8C370.784 331.355 374.971 326.819 380.4 326.4L464 326.4C472.8 326.4 476.8 330.8 476.8 336.8Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
        <path
          d="M476.8 527.6C477.258 533.104 473.168 537.936 467.664 538.396 467.642 538.396 467.621 538.4 467.6 538.4L381.6 538.4C376.002 538.632 371.226 534.388 370.8 528.8L370.8 464C370.575 458.48 374.866 453.824 380.384 453.6 380.389 453.6 380.395 453.6 380.4 453.6L464 453.6C472.8 453.6 476.8 457.6 476.8 464Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
        <path
          d="M234.8 60.4 286.4 60.4 286.4 204.4C286.4 210.806 281.206 216 274.8 216L223.6 216C217.193 216 212 210.806 212 204.4L212 84.4C211.337 71.8252 220.994 61.0944 233.568 60.4316 233.978 60.41 234.389 60.3996 234.8 60.4Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
        <path
          d="M234.8 60.4 286.4 60.4 286.4 204.4C286.4 210.806 281.206 216 274.8 216L223.6 216C217.193 216 212 210.806 212 204.4L212 84.4C211.337 71.8252 220.994 61.0944 233.568 60.4316 233.978 60.41 234.389 60.3996 234.8 60.4Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="0.5"
        />
        <path
          d="M817.6 60.4 869.2 60.4C881.792 60.4 892 70.608 892 83.2L892 203.2C892 209.606 886.808 214.8 880.4 214.8L828.8 214.8C822.392 214.8 817.2 209.606 817.2 203.2L817.2 60.4 817.6 60.4Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
        <path
          d="M817.6 60.4 869.2 60.4C881.792 60.4 892 70.608 892 83.2L892 203.2C892 209.606 886.808 214.8 880.4 214.8L828.8 214.8C822.392 214.8 817.2 209.606 817.2 203.2L817.2 60.4 817.6 60.4Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="0.5"
        />
        <path
          d="M892 83.2 892 133.2 212 133.2 212 83.2C212 70.608 222.208 60.4 234.8 60.4L869.6 60.4C882.036 60.6184 892.002 70.7624 892 83.2Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
        <path
          d="M223.6 510.4 275.2 510.4C281.606 510.4 286.8 515.592 286.8 522L286.8 666 234.8 666C222.208 666 212 655.792 212 643.2L212 520C212.982 514.384 217.9 510.316 223.6 510.4Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
        <path
          d="M223.6 510.4 275.2 510.4C281.606 510.4 286.8 515.592 286.8 522L286.8 666 234.8 666C222.208 666 212 655.792 212 643.2L212 520C212.982 514.384 217.9 510.316 223.6 510.4Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="0.5"
        />
        <path
          d="M828.8 510.4 880.4 510.4C886.808 510.4 892 515.592 892 522L892 642C892 654.592 881.792 664.8 869.2 664.8L817.6 664.8 817.6 520C818.556 514.532 823.252 510.508 828.8 510.4Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
        <path
          d="M828.8 510.4 880.4 510.4C886.808 510.4 892 515.592 892 522L892 642C892 654.592 881.792 664.8 869.2 664.8L817.6 664.8 817.6 520C818.556 514.532 823.252 510.508 828.8 510.4Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="0.5"
        />
        <path
          d="M212 643.2 212 593.2 892 593.2 892 643.2C892 655.792 881.792 666 869.2 666L234.8 666C222.208 666 212 655.792 212 643.2Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
      </g>
    </g>
  </Icon>
);
